export default __webpack_public_path__ + "static/media/0x873801ae2ff12d816db9a7b082f5796bec64c82c.b803c8be.webp";